<form (ngSubmit)="submit()" novalidate [formGroup]="form">
  <ion-list>
    <ion-item>
      <ion-label floating>
        @if (formErrors.has('verificationCode')) {
          <span color="danger"><br />{{formErrors.get('verificationCode')}}</span>
        }
      </ion-label>
      <ion-input formControlName="verificationCode" type="text" [placeholder]="verificationCodePlaceHolder"></ion-input>
    </ion-item>

    <ion-item>
      <ion-label floating>
        @if (formErrors.has('password')) {
          <span color="danger"><br />{{formErrors.get('password')}}</span>
        }
      </ion-label>
      <ion-input formControlName="password" type="password" [placeholder]="passwordPlaceHolder"></ion-input>
    </ion-item>

    <ion-item>
      <ion-label floating>
        @if (formErrors.has('confirmPassword')) {
          <span color="danger"><br />{{formErrors.get('confirmPassword')}}</span>
        }
      </ion-label>
      <ion-input formControlName="confirmPassword" type="password" [placeholder]="confirmPasswordPlaceHolder"></ion-input>
    </ion-item>
  </ion-list>

  <div padding>
    <ion-button type="submit" [disabled]="!form.valid" ion-button color="primary" expand="block">
      {{ 'Auth.UpdatePassword' | translate }}
    </ion-button>
  </div>
</form>